import styled from 'styled-components';
import { IFilterMenuLi } from 'src/pages/CatalogPage/components/FilterMenu/FilterMenuOption/FilterMenuOption.i';
import { RadioInputOption } from 'src/components/Input/RadioInput/RadioInput';
import { RadioButton } from 'src/components/Input/RadioInput/RadioInput.style';
import { IRadioInputProps } from 'src/components/Input/RadioInput/RadioInput.i';

export const FilterFacetCount = styled.span`
  margin-left: 5px;
`;

export const FilterOptionLi = styled.li<IFilterMenuLi>`
  ${(props) => (props.addedStyle ? props.addedStyle : '')}
`;

export const FilterOptionRadio = styled(RadioInputOption)<IRadioInputProps>`
  ${RadioButton} {
    border: 1px solid ${(props) => props.theme.black[90]};
    background: ${(props) => props.checked ? props.theme.black[90] : ''};
    ${(props) => props.disabled ? `border: 1px solid ${props.theme.black[60]};` : ''}
  }
  && {
    ${(props) => props.disabled ? `color: ${props.theme.black[60]};` : ''}
  }
`;
